import React from 'react';
import HomePageTable from './homePageTable';

const Home = (props) => {

  return (
      <HomePageTable></HomePageTable>
  );
}

export default Home;
